document.addEventListener('algolia.hooks.initialize', function() {
  
  // Helper function for debounce delay
  const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
  
  // Add 500ms debounce for autocomplete to reduce API calls
  algoliaShopify.hooks.registerHook('beforeAutocompleteAsyncFunction', async function() {
    await sleep(500);
  });
  
  // // Configure autocomplete options to enable query suggestions
  // algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
  //   // Force enable query suggestions even if config has it disabled
  //   const updatedOptions = {
  //     ...options,
  //     nbQuerySuggestions: 8,
  //     plugins: options.plugins || [],
  //   };
    
  //   // Ensure query suggestions plugin is included if it exists
  //   if (algoliaShopify.querySuggestionsPlugin && 
  //       !updatedOptions.plugins.includes(algoliaShopify.querySuggestionsPlugin)) {
  //     updatedOptions.plugins.push(algoliaShopify.querySuggestionsPlugin);
  //   }
    
  //   return updatedOptions;
  // });

  // Customize individual product template
  algoliaShopify.hooks.registerHook('beforeAutocompleteProductTemplate', function(defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
    const { html, item, components } = templateOptions;
    
    if (typeof html !== 'function') {
      return defaultTemplate;
    }

    // Split title by " - " to get product title and variant title
    // [0] is product title, [1] is variant title (size), [2] and beyond are disregarded
    const titleParts = item.title.split(' - ');
    const productTitle = titleParts[0] || item.title;
    const variantTitle = titleParts.length > 1 ? titleParts[1] : '';

    return html`
      <a
        href=${itemLink}
        class="aa-ItemLink aa-ProductItem"
        onClick=${() => trackSearchAttribution(item)}
      >
        <div class="aa-ItemContent">
          <div class="aa-ItemPicture aa-ItemPicture--loaded">
            <img
              src=${algoliaShopify.helpers.renderImage(item, 125).src}
              srcset=${algoliaShopify.helpers.renderImage(item, 125).srcset}
              sizes=${algoliaShopify.helpers.renderImage(item, 125).sizes}
              alt=${item.title}
            />
          </div>
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentTitleWrapper">
              <div class="aa-ItemContentTitle">
                ${productTitle}
              </div>
              ${variantTitle ? html`
                <div class="aa-ItemContentVariant">
                  ${variantTitle}
                </div>
              ` : ''}
            </div>
          </div>
        </div>
      </a>
    `;
  });

  // Add "See All" footer button
  algoliaShopify.hooks.registerHook('beforeAutocompleteFooterTemplate', function(defaultTemplate, templateOptions, items, query) {
    const { html } = templateOptions;
    
    if (typeof html !== 'function' || !query || query.trim() === '') {
      return null;
    }

    return html`
      <div class="aa-Footer">
        <a href=${`/search?q=${encodeURIComponent(query)}`} class="aa-SeeAllLink">
          See All "${query}"
        </a>
      </div>
    `;
  });

  // Customize individual query suggestion items
  algoliaShopify.hooks.registerHook('beforeAutocompleteSuggestionsTemplate', function(_defaultTemplate, templateOptions) {
    const { html, item, components } = templateOptions;
    
    return html`
      <a
        class="aa-ItemLink aa-SuggestionItem"
        href="${window.Shopify.routes.root}search?q=${encodeURIComponent(item.query)}"
      >
        <div class="aa-ItemContent">
          <div class="aa-ItemIcon aa-ItemIcon--noBorder">
            <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
              <path d="M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z" />
            </svg>
          </div>
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: 'query' })}
            </div>
          </div>
        </div>
      </a>
    `;
  });

  // Customize main template layout with query suggestions and products
  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
    const { html } = templateOptions;
    
    // Don't return the default template and return a custom two-column layout instead
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <div class="aa-PanelSections">
          <div class="aa-PanelSection--left">
            ${displaySuggestions &&
              html`
                <div class="aa-SourceHeader aa-SourceHeader-display">
                  <span class="aa-SourceHeaderTitle aa-sourceHeaderTitle-display">SUGGESTIONS</span>
                  <div class="aa-SourceHeaderLine" />
                </div>
                ${elements.querySuggestionsPlugin}
              `}
          </div>
          <div class="aa-PanelSection--right">
            ${elements.products &&
              html`
                <div class="aa-SourceHeader aa-SourceHeader-display">
                  <span class="aa-SourceHeaderTitle aa-sourceHeaderTitle-display">PRODUCTS</span>
                  <div class="aa-SourceHeaderLine" />
                </div>
                ${elements.products}
              `}
          </div>
        </div>
      </div>
    `;
  });

  // Transform product response to ensure we get products not variants
  algoliaShopify.hooks.registerHook('beforeAutocompleteProductTransformResponseHits', function(hits) {
    // Group variants by product and return only unique products
    const productsMap = new Map();
    
    hits.forEach(hit => {
      const productId = hit.product_id || hit.objectID;
      if (!productsMap.has(productId)) {
        productsMap.set(productId, hit);
      }
    });
    
    return Array.from(productsMap.values());
  });

});

